import React from 'react';
import icon from '../../assets/fission-entry.webp';
import {FloatingBubble} from 'antd-mobile';
import {goTo} from '@utils';
import {useShowLeaderboardRect} from '@/common-pages/leaderboard/hooks/useShowLeaderboardRect';

export default function FissionEntry() {
  const leaderTypes = useShowLeaderboardRect();
  if (!leaderTypes.FISSION_RANK_ACTIVITY) return null;
  return (
    <FloatingBubble
      axis="xy"
      magnetic="x"
      style={{
        '--initial-position-bottom': '106px',
        '--initial-position-right': '22px',
        '--edge-distance': '24px',
        '--size': '68px',
        '--background': 'transparent',
      }}>
      <div
        className="size-full bg-full"
        style={{backgroundImage: `url(${icon})`}}
        onClick={() => {
          goTo('Leaderboard', {
            type: 'FISSION_RANK_ACTIVITY',
          });
        }}></div>
    </FloatingBubble>
  );
}
